import React from 'react';
import { getLocalizedText, GAP_PLACEHOLDER } from '../lib/questionText';
import SentenceInput from './SentenceInput';
import {
  button,
  card,
  cardHeader,
  cardNumber,
  dangerButton,
  hint,
  input,
  label as labelStyle,
  warning,
} from '../../../shared/ui/formStyles';

// Одно задание с пропуском: текст + принимаемые ответы.
// Синонимы добавляются кнопкой, а не через разделители в одной строке.
const GapCard = ({ group, index, questionWeight, onChange, onCopy, onRemove }) => {
  const answers = group.acceptedAnswers || [];
  const text = getLocalizedText(group.label);
  const hasGap = text.includes(GAP_PLACEHOLDER);
  const customWeight =
    typeof group.weight === 'number' && group.weight !== questionWeight ? group.weight : null;

  const setText = (nextText) => {
    // Украинскую подпись не трогаем, если она отличается от английской.
    const ua = group.label?.ua;
    const en = group.label?.en;
    onChange({
      ...group,
      label: ua && ua !== en ? { ua, en: nextText } : { ua: nextText, en: nextText },
    });
  };

  const setAnswer = (answerIndex, nextValue) => {
    const nextAnswers = [...answers];
    nextAnswers[answerIndex] = nextValue;
    onChange({ ...group, acceptedAnswers: nextAnswers });
  };

  return (
    <div style={card}>
      <div style={cardHeader}>
        <span style={cardNumber}>Речення {index + 1}</span>
        {!text.trim() && <span style={warning}>Немає тексту</span>}
        {answers.filter((answer) => answer.trim()).length === 0 && (
          <span style={warning}>Немає відповіді</span>
        )}
        {customWeight !== null && <span style={warning}>Балів: {customWeight}</span>}

        <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
          <button type="button" onClick={onCopy} style={button}>
            Копіювати
          </button>
          <button type="button" onClick={onRemove} style={dangerButton}>
            Видалити
          </button>
        </div>
      </div>

      <SentenceInput
        title="Текст речення"
        value={text}
        onChange={setText}
        placeholder="Наприклад: James lives ___ Cambridge."
      />

      <div style={{ marginTop: '16px' }}>
        <span style={labelStyle}>Правильна відповідь</span>

        {(answers.length > 0 ? answers : ['']).map((answer, answerIndex) => (
          <div
            key={answerIndex}
            style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '8px' }}
          >
            <input
              type="text"
              value={answer}
              placeholder={answerIndex === 0 ? 'Наприклад: in' : 'Інший прийнятний варіант'}
              onChange={(e) => setAnswer(answerIndex, e.target.value)}
              style={input}
            />
            {answers.length > 1 && (
              <button
                type="button"
                onClick={() =>
                  onChange({
                    ...group,
                    acceptedAnswers: answers.filter((_, i) => i !== answerIndex),
                  })
                }
                style={dangerButton}
              >
                Прибрати
              </button>
            )}
          </div>
        ))}

        <button
          type="button"
          onClick={() => onChange({ ...group, acceptedAnswers: [...answers, ''] })}
          style={button}
        >
          + Ще один правильний варіант
        </button>
        <p style={hint}>
          Додайте варіант, якщо відповідь можна написати по-різному (наприклад «is not» та «isn't»).
          Великі літери, крапки й коми система не звіряє.
        </p>
      </div>

      {(hasGap || answers[0]) && (
        <div
          style={{
            marginTop: '16px',
            padding: '12px 14px',
            background: '#F8FAFC',
            borderRadius: '8px',
          }}
        >
          <span style={{ ...labelStyle, marginBottom: '8px' }}>Так це побачить студент</span>
          <div style={{ fontSize: '15px', color: '#0F172A', marginBottom: '6px' }}>
            {text || '…'}
          </div>
          <div
            style={{
              display: 'inline-block',
              minWidth: '140px',
              padding: '7px 12px',
              border: '1px solid #C7D8FF',
              borderRadius: '6px',
              background: '#fff',
              color: '#2D9E6B',
              fontSize: '14px',
            }}
          >
            {answers.find((answer) => answer.trim()) || 'поле для відповіді'}
          </div>
        </div>
      )}
    </div>
  );
};

export default GapCard;
